import extractCollection from "./extractCollection";
import { fetchFromInfoSpace } from "./fetchGraphQL";
import { GetAllArticles } from "./queries";

type Props = {
  limit?: number;
  category?: string;
  notCategory?: string[];
  preview?: boolean;
  excludeMultiple?: string[];
  excludeId?: string;
  exclude?: string[];
  pageNumber?: number;
  inWebPromoWindow?: boolean;
  tags?: string[];
  siteCategories?: string[];
  skip?: number;
};

export default async function getAllArticles({
  limit = 3, //max 36 otherwise exceeds complexity limit
  category = "",
  notCategory = [],
  preview = false,
  exclude = [],
  excludeId = "",
  pageNumber = 0,
  inWebPromoWindow = false,
  siteCategories = [],
  tags = [],
  skip = 0,
}: Props = {}): Promise<Collection<Article>> {
  const where: any = { sys: {}, categories: {} };
  if (siteCategories.length) {
    where.categories.slug_in = siteCategories;
  }
  if (category) {
    where.categories.slug = category;
  }
  if (notCategory.length) {
    where.categories.slug_not_in = notCategory;
  }
  if (exclude.length) {
    where.slug_not_in = exclude;
  }
  if (excludeId) {
    where.sys.id_not = excludeId;
  }
  if (inWebPromoWindow) {
    // TODO: consider how this is breaking the cache. Maybe we can find a way
    // to make this more cache friendly
    const curDate = new Date().toISOString();
    if (!where.OR) {
      where.OR = [];
    }
    where.OR = [
      ...where.OR,
      {
        webPromoStartDate_lte: curDate,
        webPromoEndDate_gte: curDate,
      },
      {
        webPromoStartDate_lte: curDate,
        webPromoEndDate_exists: false,
      },
      {
        webPromoStartDate_exists: false,
        webPromoEndDate_gte: curDate,
      },
      {
        webPromoStartDate_exists: false,
        webPromoEndDate_exists: false,
      },
    ];
  }
  const fetchResponse = await fetchFromInfoSpace(
    {
      query: GetAllArticles,
      variables: {
        where,
        limit,
        preview,
        skip: skip || limit * pageNumber,
      },
    },
    ["GetAllArticles", "collection", ...tags],
  );
  if (fetchResponse?.errors) {
    console.error(fetchResponse.errors);
  }
  return extractCollection(fetchResponse);
}
